
import * as actionTypes from "./types";
import { combineReducers } from "redux";

const initial_game_state={
    // authStatus:false,
    gameData:{}
}

const game_reducer=(state=initial_game_state,action)=>
{
    switch (action.type) {
        case actionTypes.SET_GAME_DATA:
            return{
                ...state,
                gameData: action.payload.gameData,
            }
        // case actionTypes.SET_AUTH_STATUS:
        //     return{
        //         ...state,
        //         authStatus: action.payload.authStatus,
        //     }
        default:return state
    }
}





const rootReducer = combineReducers({
     game:game_reducer
})


export default rootReducer